import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import UpdateCreditCardButton from '../../components/UpdateCreditCardButton';
import { Button } from 'primereact/button';

const i18nMessages = defineMessages({
  change: {
    id: 'actions.change',
    defaultMessage: 'Change',
  },
  stop: {
    id: 'actions.stop',
    defaultMessage: 'Stop',
  },
});

const ActiveSubscriptionActionButtons = ({
  redirectToChangeSubscriptionPage,
  redirectToStopSubscriptionPage,
  managingAccountId,
  clientAccountId,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="existing-subscription-info">
      <Button
        type="button"
        label={formatMessage(i18nMessages.change)}
        className="p-button-primary"
        onClick={redirectToChangeSubscriptionPage}
      />
      <Button
        type="button"
        label={formatMessage(i18nMessages.stop)}
        className="p-button-danger"
        onClick={redirectToStopSubscriptionPage}
      />
      <UpdateCreditCardButton managingAccountId={managingAccountId} clientAccountId={clientAccountId} />
    </div>
  );
};

export default ActiveSubscriptionActionButtons;
